import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Question as QuestionMark } from '@zocdoc-frontend-common/assets-icons';
import { TOOLTIP, Tooltip } from '@zocdoc-frontend-common/components-tooltip';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import {
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { blue100, slate80 } from '@zocdoc-mezzanine/foundations-colors';
import { paragraphSmall } from '@zocdoc-mezzanine/foundations-typography';

const tooltipMessage =
    "We collect this information because it may be needed for insurance purposes. If you'd like to share your gender with the provider, use the notes section on the next page.";

/**
 * @description A tooltip that explains why we collect user's sex, and how they can provide gender info
 * @param {function(params: Object|null): void} sendMetric
 * @returns {JSX.Element}
 * @constructor
 */
function BaseSexAssignedAtBirthTooltip({ sendMetric }) {
    const anchor = (
        <StyledQuestionMark
            color={slate80}
            height={16}
            data-test="sex-assigned-at-birth-tooltip-anchor"
        />
    );

    const handleViewTooltip = useCallback(() => {
        sendMetric({
            action: 'Viewed SexAssignedAtBirthTooltip',
        });
    }, [sendMetric]);

    return (
        <TooltipWrapper>
            <StyledTooltip
                anchor={anchor}
                onViewTooltip={handleViewTooltip}
                showTooltipOnFocus
                showTooltipOnHover
                tooltipPosition={TOOLTIP.RIGHT}
            >
                <Message data-test="sex-assigned-at-birth-tooltip">
                    {tooltipMessage}
                </Message>
            </StyledTooltip>
        </TooltipWrapper>
    );
}

const Message = styled.p`
    color: ${blue100};
    ${paragraphSmall}
`;

const StyledQuestionMark = styled(QuestionMark)`
    margin-left: 8px;
`;

const StyledTooltip = styled(Tooltip)`
    width: 350px;
`;

const TooltipWrapper = styled.div`
    margin: auto 0;
`;

/**
 * @description A tooltip that explains why we collect user's sex, and how they can provide gender info
 * @returns {JSX.Element}
 */
export const SexAssignedAtBirthTooltip = withCustomMetrics({
    component: 'SexAssignedAtBirthTooltip',
    element: 'SexAssignedAtBirthTooltip',
    initiator: EVENT_INITIATORS.USER,
    interactionType: INTERACTION_TYPES.VIEW,
})(BaseSexAssignedAtBirthTooltip);
